export default "/images/244c75d526426b773da596d713720397.jpg";